import { render, staticRenderFns } from "./modal-remove-article-watch.vue?vue&type=template&id=7fd5ac3a&"
import script from "./modal-remove-article-watch.vue?vue&type=script&lang=js&"
export * from "./modal-remove-article-watch.vue?vue&type=script&lang=js&"
import style0 from "./modal-remove-article-watch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports